import {OTTO_V2_API} from '@/api/otto-v2';
import {apiError} from '@/utils/api';
import {timeNotification} from '@/utils/notification-timer';
import {notification} from '@/utils/notification-v2';
import {faCircleCheck} from '@fortawesome/pro-regular-svg-icons';
import {faXmark} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Checkbox, ModalProps} from 'antd';
import {observer} from 'mobx-react';
import {useState} from 'react';
import {StyledButton, StyledModal} from './styles';

interface IrrelevantTermsModalProps extends ModalProps {
  modalConfig: any;
  setModalConfig: (value: any) => void;
  uuid: string;
  loadTableData: any;
}

const IrrelevantTermsModal = observer(({modalConfig, setModalConfig, uuid, loadTableData, ...props}: IrrelevantTermsModalProps) => {
  const [selectedTerms, setSelectedTerms] = useState<any[]>(modalConfig?.terms?.map((term: any) => term?.index) || []);

  const handleRemoveTerms = async (recordId, uuid, terms) => {
    try {
      const payload = {
        uuid,
        issue_type: 'nlp_terms',
        item_indexes: terms,
        to_delete: true,
      };
      await OTTO_V2_API.removeIrrelevantNlpTerms(recordId, uuid, payload);
      loadTableData();
    } catch (error) {
      const errorMessage = apiError(error);
      notification.error('Failed to remove terms', errorMessage);
    }
  };

  const onRemoveTerms = async () => {
    try {
      const terms = selectedTerms.map(i => i);
      const recordId = modalConfig?.id;
      timeNotification('#549E79', faCircleCheck, 4, `Trimmed Successfully`, () => {}, '#549E79', () => handleRemoveTerms(recordId, uuid, terms));
      setModalConfig({...modalConfig, visible: false, terms: [], id: null});
    } catch (error) {
      const errorMessage = apiError(error);
      notification.error('Failed to remove terms', errorMessage);
    }
  };

  return (
    <StyledModal
      width={450}
      open={modalConfig?.visible}
      onCancel={() => setModalConfig({...modalConfig, visible: false, terms: [], id: null})}
      footer={null}
      closeIcon={<FontAwesomeIcon icon={faXmark} fontSize={20} />}
      centered
      {...props}
    >
      <div className='wrapper'>
        <div className='title'>AI Terms Trimming</div>
        <div className='description'>AI has identified {modalConfig?.terms?.length} terms that may be incorrect or irrelevant. Uncheck any terms you want to keep.</div>
        <div className='checkboxWrapper'>
          <Checkbox.Group value={selectedTerms} onChange={value => setSelectedTerms(value)} options={modalConfig?.terms?.map((term: any) => ({label: term?.term, value: term?.index}))} />
        </div>
        <div className='button-wrapper'>
          <button onClick={() => setModalConfig({...modalConfig, visible: false, terms: [], id: null})} className='cancelButton'>Cancel</button>
          <StyledButton className='submitButton' disabled={!selectedTerms?.length} onClick={onRemoveTerms}>Remove {selectedTerms?.length} term{selectedTerms?.length > 1 ? 's' : ''}</StyledButton>
        </div>
      </div>
    </StyledModal>
  );
});

export default IrrelevantTermsModal;

